import { Controller } from '@hotwired/stimulus';
import { WebViewEvent, checkIfWebView } from '@infakt/webview-toolkit';

export default class extends Controller {
  static values = {
    url: String,
    title: String,
    requireSession: { type: Boolean, default: false },
    externalLink: { type: Boolean, default: false },
  };

  sendEvent() {
    if (checkIfWebView()) {
      return new WebViewEvent({
        event: 'OpenInModal',
        params: {
          url: this.urlValue,
          title: this.titleValue,
          requireSession: this.requireSessionValue,
          externalLink: this.externalLinkValue,
        },
      }).dispatch();
    }
  }
}
